module.exports = __webpack_public_path__ + "static/media/about-portrait.9fb07c51.jpg";